import CommonButton from './CommonButton';

export { CommonButton };
